import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {reactive} from 'vue'
import {useStore} from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore()

const data = reactive<any>({
  font: {
    color: 'rgba(0, 0, 0, .1)'
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_watermark = _resolveComponent("el-watermark")!

  return (_openBlock(), _createBlock(_component_el_watermark, {
    font: data.font,
    content: [_unref(store).getters.admin.trueName, _unref(store).getters.admin.mobile],
    "z-index": 9999
  }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }, 8, ["font", "content"]))
}
}

})